import { render, staticRenderFns } from "./secondlogin.vue?vue&type=template&id=696bbb24&scoped=true&"
import script from "./secondlogin.vue?vue&type=script&lang=js&"
export * from "./secondlogin.vue?vue&type=script&lang=js&"
import style0 from "./secondlogin.vue?vue&type=style&index=0&id=696bbb24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696bbb24",
  null
  
)

export default component.exports